export default __webpack_public_path__ + "static/media/ICONA_LIGHT1.20f809d9.svg";